import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API } from '../contexts/AuthContext';
import axios from 'axios';

const fmt = (v) => Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtQtd = (v) => Number(v || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 });
const fmtData = (d) => d ? new Date(d).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : '';

export default function RelatorioComissaoExtra() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);
  const [expandido, setExpandido] = useState(null); // codvend
  const [drilldown, setDrilldown] = useState({}); // codvend → dados
  const [filiais, setFiliais] = useState([]);
  const [filtroFilial, setFiltroFilial] = useState('');
  const [busca, setBusca] = useState('');

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/relatorio-comissao/${id}`)
      .then(r => setData(r.data))
      .catch(e => setErro(e.response?.data?.error || 'Erro ao carregar relatório'))
      .finally(() => setLoading(false));
    axios.get(`${API}/filiais`).then(r => setFiliais(r.data)).catch(() => {});
  }, [id]);

  const nomeFilial = (cod) => {
    const f = filiais.find(x => String(x.codigo).padStart(2, '0') === String(cod).padStart(2, '0'));
    return f ? f.nome : `Filial ${cod}`;
  };

  const toggleVendedor = async (codvend) => {
    if (expandido === codvend) { setExpandido(null); return; }
    setExpandido(codvend);
    if (!drilldown[codvend]) {
      try {
        const r = await axios.get(`${API}/relatorio-comissao/${id}/vendedor/${codvend}`);
        setDrilldown(prev => ({ ...prev, [codvend]: r.data }));
      } catch (e) {
        setDrilldown(prev => ({ ...prev, [codvend]: { erro: e.response?.data?.error || 'Erro' } }));
      }
    }
  };

  if (loading) return <div className="d-flex justify-content-center p-5"><div className="spinner-border" style={{ color: '#6B2C5C' }} /></div>;
  if (erro) return <div className="alert alert-danger m-4">{erro}</div>;
  if (!data) return null;

  const semComissao = data.produtos.length === 0;

  // Filtragem
  const vendedoresFiltrados = data.vendedores.filter(v => {
    if (filtroFilial && v.filial !== filtroFilial) return false;
    if (busca && !`${v.nome} ${v.codvend}`.toLowerCase().includes(busca.toLowerCase())) return false;
    return true;
  });

  return (
    <div className="container-fluid p-4">
      <div className="d-flex align-items-center mb-3 flex-wrap gap-2">
        <button className="btn btn-link p-0" onClick={() => navigate('/campanhas')}>
          <i className="bi bi-arrow-left"></i> Voltar
        </button>
        <h4 className="mb-0 ms-2" style={{ color: '#2D1427' }}>
          <i className="bi bi-cash-coin me-2"></i>Relatório Comissão Extra
        </h4>
      </div>

      <div className="card mb-3" style={{ borderLeft: '4px solid #6B2C5C' }}>
        <div className="card-body py-3">
          <div className="row g-3">
            <div className="col-md-5">
              <div className="text-muted small">Campanha</div>
              <div className="fw-semibold">{data.campanha.nome}</div>
            </div>
            <div className="col-md-3">
              <div className="text-muted small">Período</div>
              <div className="fw-semibold">{fmtData(data.campanha.data_inicio)} → {fmtData(data.campanha.data_fim)}</div>
            </div>
            <div className="col-md-2">
              <div className="text-muted small">Produtos c/ comissão</div>
              <div className="fw-semibold">{data.produtos.length}</div>
            </div>
            <div className="col-md-2">
              <div className="text-muted small">Comissão extra total</div>
              <div className="fw-bold" style={{ color: '#6B2C5C', fontSize: '1.15rem' }}>R$ {fmt(data.totais.comissao_extra)}</div>
            </div>
          </div>
        </div>
      </div>

      {semComissao && (
        <div className="alert alert-warning">
          <i className="bi bi-exclamation-triangle me-2"></i>
          Nenhum produto desta campanha tem comissão extra cadastrada. Defina a comissão na tela de produtos da campanha.
        </div>
      )}

      {!semComissao && (
        <>
          <div className="card mb-3">
            <div className="card-body py-2">
              <div className="row g-2">
                <div className="col-md-4">
                  <input className="form-control form-control-sm" placeholder="Buscar vendedor..." value={busca} onChange={e => setBusca(e.target.value)} />
                </div>
                <div className="col-md-3">
                  <select className="form-select form-select-sm" value={filtroFilial} onChange={e => setFiltroFilial(e.target.value)}>
                    <option value="">Todas as filiais</option>
                    {filiais.map(f => (
                      <option key={f.codigo} value={String(f.codigo).padStart(2, '0')}>{f.nome}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-5 text-end small text-muted d-flex align-items-center justify-content-end">
                  Mostrando {vendedoresFiltrados.length} de {data.vendedores.length} vendedores
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="table-responsive">
              <table className="table table-sm table-hover mb-0" style={{ fontSize: '0.88rem' }}>
                <thead style={{ backgroundColor: '#F5EBF2' }}>
                  <tr>
                    <th style={{ width: 30 }}></th>
                    <th>Filial</th>
                    <th>Vendedor</th>
                    <th className="text-end">Qtd vendida</th>
                    <th className="text-end">Venda bruta</th>
                    <th className="text-end text-danger">Devolução</th>
                    <th className="text-end text-danger">Cancelamento</th>
                    <th className="text-end">Venda líquida</th>
                    <th className="text-end" style={{ color: '#6B2C5C' }}>Comissão extra</th>
                  </tr>
                </thead>
                <tbody>
                  {vendedoresFiltrados.map(v => (
                    <React.Fragment key={`${v.filial}-${v.codvend}`}>
                      <tr style={{ cursor: 'pointer' }} onClick={() => toggleVendedor(v.codvend)}>
                        <td><i className={`bi bi-chevron-${expandido === v.codvend ? 'down' : 'right'}`}></i></td>
                        <td><span className="badge bg-secondary">{nomeFilial(v.filial)}</span></td>
                        <td className="fw-semibold">{v.nome} <span className="text-muted small">({v.codvend})</span></td>
                        <td className="text-end">{fmtQtd(v.qtd_vendida)}</td>
                        <td className="text-end">R$ {fmt(v.venda_bruta)}</td>
                        <td className="text-end text-danger">{v.valor_devol > 0 ? `−R$ ${fmt(v.valor_devol)}` : '—'}</td>
                        <td className="text-end text-danger">{v.valor_cancel > 0 ? `−R$ ${fmt(v.valor_cancel)}` : '—'}</td>
                        <td className="text-end">R$ {fmt(v.venda_liquida)}</td>
                        <td className="text-end fw-bold" style={{ color: '#6B2C5C' }}>R$ {fmt(v.comissao_extra)}</td>
                      </tr>
                      {expandido === v.codvend && (
                        <tr>
                          <td colSpan="9" style={{ backgroundColor: '#FAFAFA', padding: 0 }}>
                            <Drilldown dados={drilldown[v.codvend]} />
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                  {vendedoresFiltrados.length === 0 && (
                    <tr><td colSpan="9" className="text-center text-muted py-4">Nenhum vendedor encontrado</td></tr>
                  )}
                </tbody>
                <tfoot style={{ backgroundColor: '#F5EBF2', fontWeight: 600 }}>
                  <tr>
                    <td colSpan="3" className="text-end">TOTAL</td>
                    <td className="text-end">{fmtQtd(data.totais.qtd_vendida)}</td>
                    <td className="text-end">R$ {fmt(data.totais.venda_bruta)}</td>
                    <td className="text-end text-danger">−R$ {fmt(data.totais.valor_devol)}</td>
                    <td className="text-end text-danger">−R$ {fmt(data.totais.valor_cancel)}</td>
                    <td className="text-end">R$ {fmt(data.totais.venda_bruta - data.totais.valor_devol - data.totais.valor_cancel)}</td>
                    <td className="text-end" style={{ color: '#6B2C5C' }}>R$ {fmt(data.totais.comissao_extra)}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

function Drilldown({ dados }) {
  if (!dados) return <div className="p-3 text-muted small"><div className="spinner-border spinner-border-sm me-2" />Carregando detalhes...</div>;
  if (dados.erro) return <div className="p-3 text-danger small">{dados.erro}</div>;

  const { vendas = [], devolucoes = [], cancelamentos = [] } = dados;
  const linhas = [
    ...vendas.map(l => ({ ...l, _tipo: 'venda' })),
    ...devolucoes.map(l => ({ ...l, _tipo: 'devol' })),
    ...cancelamentos.map(l => ({ ...l, _tipo: 'cancel' })),
  ].sort((a, b) => new Date(a.data) - new Date(b.data));

  if (linhas.length === 0) return <div className="p-3 text-muted small">Sem movimentações no período.</div>;

  const tipoBadge = (t) => {
    if (t === 'venda') return <span className="badge bg-success">venda</span>;
    if (t === 'devol') return <span className="badge bg-danger">devolução</span>;
    return <span className="badge bg-secondary" title="Cancelado — não conta na comissão">cancelado</span>;
  };

  return (
    <div className="p-2">
      <table className="table table-sm mb-0" style={{ fontSize: '0.82rem' }}>
        <thead>
          <tr className="text-muted">
            <th>Data</th>
            <th>Tipo</th>
            <th>Documento</th>
            <th>Produto</th>
            <th className="text-end">Qtd</th>
            <th className="text-end">Valor</th>
            <th className="text-end">Comissão R$/un</th>
            <th className="text-end">Comissão linha</th>
          </tr>
        </thead>
        <tbody>
          {linhas.map((l, i) => {
            const isCancel = l._tipo === 'cancel';
            return (
              <tr key={i} className={l._tipo === 'devol' ? 'text-danger' : ''} style={isCancel ? { opacity: 0.55 } : undefined}>
                <td>{fmtData(l.data)}</td>
                <td>{tipoBadge(l._tipo)}</td>
                <td><span className="text-muted small">{l.tipo_doc}</span> {l.documento}</td>
                <td>{l.codpro} — {l.descricao}</td>
                <td className="text-end">{fmtQtd(l.qtd)}</td>
                <td className="text-end">R$ {fmt(l.valor)}</td>
                <td className="text-end">R$ {fmt(l.comissao_unit)}</td>
                <td className="text-end fw-semibold">{l.comissao_linha == null ? '—' : `R$ ${fmt(l.comissao_linha)}`}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
